<div id="openExtendsRecordGuide" class="modal fade in" tabindex="-1" role="dialog" data-backdrop="static"
  data-keyboard="false">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title mt-0 text-dark bold" id="mySmallModalLabel">HISTORIAL DEL GUIA SELECCIONADO</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="close()">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <app-loading-modal></app-loading-modal>
      <div class="modal-body" *ngIf="guideSelected != null;">
        <div class="card m-b-30">
          <div class="row m-b-15">
            <div class="col-lg-12">
              <p class="f-s-15 bold" style="color: black;">
                <i class="fas fa-user m-r-5"></i>
                <span class="m-r-5">GUIA TURÍSTICO:</span>
                <span>{{guideSelected.fullname}}</span>
              </p>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-7">
              <p class="m-b-10 f-s-14"><i class="fas fa-map-pin m-r-5"></i> Tours asignados los últimos 7 días
                <span class="f-s-11 m-l-5">({{end_range.format('YYYY-MM-DD')| date: 'mediumDate'}} -
                  {{start_range.format('YYYY-MM-DD')| date: 'mediumDate'}})</span>
              </p>
              <div class="table-responsive">
                <table class="table table-hover table-bordered table-sm mb-0">
                  <thead class="thead-default">
                    <tr>
                      <th>
                        Fechas
                      </th>
                      <th>
                        Nombre tour
                      </th>
                      <th>
                        Movilidad
                      </th>
                      <th class="text-center">
                        N° Pax
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <ng-container *ngIf="items_tours_grouped.length == 0">
                      <td colspan="2"><span>No se encontraron registros</span></td>
                    </ng-container>
                    <ng-container *ngIf="items_tours_grouped.length > 0">
                      <tr *ngFor="let item of items_tours_grouped">
                        <td>{{ item.date_departure | date: 'mediumDate' }}</td>
                        <td>{{ item.description }}</td>
                        <td>{{ item.transport }}</td>
                        <td class="text-center">{{ item.capacity_selected }}</td>
                      </tr>
                    </ng-container>

                  </tbody>
                </table>
              </div>
            </div>
            <div class="col-lg-5">
              <p class="m-b-10"><i class="fas fa-map-pin m-r-5"></i>Top 10 movilidad asignada al guia <span
                  class="f-s-11 m-l-5">(últimos 30 días)</span>
              </p>
              <div class="table-responsive">
                <table class="table table-hover table-bordered table-sm mb-0">
                  <thead class="thead-default">
                    <tr>
                      <th>
                        Nombre movilidad
                      </th>
                      <th class="text-center">
                        N° Grupos
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <ng-container *ngFor="let item of items_transport">
                      <ng-container *ngIf="item.quantity_groups > 0">
                        <tr>
                          <td>{{item.description}}</td>
                          <td class="text-center">{{item.quantity_groups}}</td>
                        </tr>
                      </ng-container>
                    </ng-container>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="col-lg-12 m-t-15 p-t-10" style="border-top: 1px solid grey;">
              <p class="m-b-10"><i class="fas fa-calendar-alt m-r-5"></i>Calendario de salidas
              </p>
              <div class="row">
                <div class="col-lg-12">
                  <div class="row">
                    <div class="col-lg-4 col-12">
                      <div class="content__subhead__inputGrid m-r-5">
                        <div class="input-group" style="width: auto;">
                          <span class="input-group-prepend">
                            <span class="input-group-text content__subhead__inputGrid__title">
                              <i class="far fa-calendar-alt m-r-5"></i> Seleccionar Mes
                            </span>
                          </span>
                          <input type="text" id="date_calendar" class="form-control content__subhead__inputGrid__input"
                            readonly>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-6 col-12">
                      <div class="table-responsive">
                        <table>
                          <thead>
                            <tr>
                              <th>N° TOTAL DE SALIDAS: </th>
                              <th class="text-center p-l-5">{{data_calendar.length}} grupos asignados</th>
                            </tr>
                          </thead>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-12 m-t-25">
                  <highcharts-chart [Highcharts]="HighchartsHeatmap" [options]="chartOptionsHeatmap"
                    [(update)]="updateFlagHeatmap" (chartInstance)="chartHeatmap = $event"
                    style="width: 100%; height: 500px; display: block"></highcharts-chart>
                </div>

              </div>
            </div>
          </div>
        </div>

      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary waves-effect" data-dismiss="modal"
          (click)="close()">Cerrar</button>
      </div>
    </div>
  </div>
</div>
